export const helpers = {
  resolveContentUrl: (report) => {
    const { contentType, contentId, courseId, parentContentId } = report;

    if (contentType === "teaching") {
      return `${process.env.REACT_APP_SERVER_URL}/courses/${courseId}/teachers/${contentId}/`;
    }

    if (contentType === "comment") {
      return `${process.env.REACT_APP_SERVER_URL}/courses/${courseId}/teachers/${parentContentId}/`;
    }

    return `${process.env.REACT_APP_SERVER_URL}/courses/${courseId}/teachers/${parentContentId}/`;
  },
};
